import { render, staticRenderFns } from "./ProfileCompleteness.vue?vue&type=template&id=09e5f4cb"
import script from "./ProfileCompleteness.vue?vue&type=script&lang=ts"
export * from "./ProfileCompleteness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports